<template>
  <button
    v-if="!activeRequest"
    @click="startBuild"
    class="
      px-3
      py-1
      my-4
      bg-blue-600
      rounded
      text-white text-xl
      hover:bg-blue-800
    "
  >
    התחל עדכון חדש
  </button>
  <span
    v-else
    class="
      inline-block
      px-3
      py-1
      my-4
      bg-blue-600
      rounded
      text-white text-xl
      hover:bg-blue-800
    "
    >אנא המתן</span
  >
</template>

<script>
import requestStartBuild from "../utils/requestStartBuild";

export default {
  data() {
    return {
      activeRequest: false,
    };
  },
  methods: {
    async startBuild() {
      this.activeRequest = true;
      const response = await requestStartBuild();
      console.log(response);
      if (response) {
        this.$emit("build-started");
      } else {
        this.$emit("build-error", "cannot start build");
      }
    },
  },
};
</script>
